import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../../redux/slice/system";
import { AssessmentAPI } from "../../../../axios/api";
import {
  useAbortedEffect,
  useSearch,
  useTable,
  usePop,
} from "../../../../components/hooks";

import ModuleBreadCrumb from "../../../../components/breadCrumb";
import ModulePopTemplatePreview from "./popPreview";
import {
  formatOptions,
  setPageSetting,
  formatNumber,
} from "../../../../service/common";
import { system_dropdown, system_table } from "../../../../service/system";
import { option_enabled } from "../../../../service/option";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";

export default function BackAssessmentTemplateList() {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const crumbItem = [{ key: 1, label: "考核表管理" }];
  const [reload, setReload] = useState({ list: false });
  const {
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  // 篩選條件
  const defaultFilter = {
      page: 1,
      size: system_table.size,
      enabled: null,
    },
    pagePath = "/assessment/publish";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "preview",
      title: () => "預覽",
      isOpen: false,
    },
  ]);
  const [optionData, setOptionData] = useState(null);

  useEffect(() => {
    const action = ({ startIndex, rows }) => {
      let temp = {
        ...search,
        page: Math.floor(startIndex / rows) + 1,
        size: rows,
      };
      setFilterData(temp);
      setSearch(temp);
    };
    setPageAction(
      () =>
        ({ startIndex, rows }) =>
          action({ startIndex, rows })
    );
  }, [search]);

  useEffect(() => {
    let temp = formatOptions({
      enabled: option_enabled,
    });

    setOptionData((state) => ({
      ...state,
      ...temp,
    }));
  }, []);

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list || !optionData) return;

      dispatch(setProgress(true));

      setPageSetting({ params: search, page: pagePath });

      let params = {
        ...search,
      };

      AssessmentAPI.getExamExamplesList({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          setTbData(data);
          setTbTotalRecords(total);
          setReload((state) => ({
            ...state,
            list: false,
          }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload, optionData]
  );

  useEffect(() => {
    if (!optionData) return;

    const renderBtnAction = (data) => (
      <>
        <Button
          className="p-button-secondary p-button-sm"
          type="button"
          label="預覽"
          onClick={() => openPop({ type: "preview", data })}
        />
        <Button
          className="p-button-sm ml-2"
          type="button"
          label="編輯"
          onClick={() => route_navigate(`/back${pagePath}/${data.id}`)}
        />
      </>
    );

    setTbColumns([
      {
        field: "name",
        header: "考核名稱",
        className: "flex-grow-1",
        style: { flexBasis: "70px" },
      },
      {
        field: "remark",
        header: "備註",
        className: "flex-grow-1 white-space-prewrap",
        style: { flexBasis: "150px" },
      },
      {
        field: "id",
        header: "進階",
        className: "w-9rem froze-right",
        alignFrozen: "right",
        frozen: true,
        body: (data) => renderBtnAction(data),
      },
    ]);
  }, [pagePath, optionData]);

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">考核表管理</h2>

      <div className="border-round-lg bg-white p-3">
        {renderSearchWrap({
          isShow: false,
          template: (
            <>
              {/* <div className="col-12 md:col-4 xl:col-3 flex align-items-start flex-column mt-2 md:mt-0">
                <label
                  htmlFor="username"
                  className="w-4rem white-space-nowrap text-left mb-1"
                >
                  啟用狀態
                </label>
                <Dropdown
                  name="enabled"
                  className="w-full"
                  value={filterData.enabled}
                  onChange={(e) => changeFilter(e)}
                  options={optionData?.enabled ?? []}
                  optionLabel="label"
                  optionValue="value"
                  emptyFilterMessage={system_dropdown.emptyFilter}
                  showClear
                />
              </div> */}
              <div
                className={classNames(
                  "col-12 flex align-items-end mt-2 md:mt-0"
                )}
              >
                {/* <Button
                  className="p-button-info p-button-sm w-auto ml-auto md:ml-0 md:mt-0 px-3"
                  type="button"
                  icon="pi pi-search"
                  label="查詢"
                  onClick={() => {
                    setSearch({
                      ...filterData,
                      page: 1,
                    });
                    setTbFirstIndex(0);
                  }}
                /> */}

                <Button
                  className="p-button-warning p-button-sm w-auto md:ml-auto ml-3 px-3"
                  type="button"
                  label="新增"
                  onClick={() => route_navigate(`/back${pagePath}/add`)}
                  disabled={!!redux_user.userDetail?.isAssessment}
                />
              </div>
            </>
          ),
        })}

        {!!redux_user.userDetail?.isAssessment && (
          <div className="text-red-400 text-right mt-1">
            * 考核時段(1、4、7、10月)，無法新增考核表
          </div>
        )}

        {renderTable({
          className: "mt-2",
          options: { scrollable: true, scrollDirection: "both" },
        })}
      </div>

      {renderDialog({
        className: "w-11 md:w-10 lg:w-8",
        children: (
          <>
            {isPop.preview?.isOpen && (
              <ModulePopTemplatePreview
                prePopOption={popOption}
                closePrePop={closePop}
              />
            )}
          </>
        ),
      })}
    </>
  );
}
